import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface Input {
    chatId: string;
}

interface Options {
    onSuccess?: () => void;
}

export function useDeleteChatMutation(options?: Options) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (input: Input) => {
            const res = await apiClient.deleteChat({
                params: {
                    chatId: input.chatId,
                },
            });
            if (res.status !== 200) {
                throw new Error("Error deleting chat");
            }
            return res.body;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["chats"] });
            options?.onSuccess?.();
        },
    });
}
